import { createContextStore } from "@faire/web/ui/hooks/ContextStore";

/**
 * We can create a Context Store with the UI state that
 * we need to keep track of.
 */
const {
  useStore: useCheckoutNudgeStore,
  Provider: CheckoutNudgeContextStoreProvider,
} = createContextStore({
  isOpen: false,
  shouldConsiderNudgeInTheSession: false,
  checkoutNudgedInCurrentPage: false,
});

export { useCheckoutNudgeStore, CheckoutNudgeContextStoreProvider };
